<script lang="ts">
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { location, push } from 'svelte-spa-router';

    import {
        END_CARD_BG_1,
        END_CARD_BG_2,
        END_CARD_TEXT_ONE,
        END_CARD_TEXT_TWO
    } from '../constants/imgList';
    import { LOGIN_STATE_CK } from '../enums/track';
    import { isLogin } from '../store/index';
    import { resetLoginFlow } from '../store/loginFlow';
    import { checkIsLogin, logout } from '../utils/passport';
    import { trackEvent } from '../utils/track';

    import webp from '@/actions/webp';

    const onLogOut = async () => {
        trackEvent(LOGIN_STATE_CK, {
            button_name: 'log_out'
        });

        try {
            await logout();
            resetLoginFlow();

            if (get(location) !== '/') {
                await push('/');
            }
        } catch (error) {
            console.error('[CardEndHeadArea logout]', error);
        }
    };

    onMount(async () => {
        await checkIsLogin();
    });
</script>

<div class="card-end-head" class:card-end-head--logged={$isLogin}>
    <div class="title-section">
        <div class="title-bg" use:webp={END_CARD_BG_1}>
            {#if $isLogin}
                <div class="title-img" use:webp={END_CARD_TEXT_TWO}></div>
            {:else}
                <div class="title-img" use:webp={END_CARD_TEXT_ONE}></div>
            {/if}
        </div>
        {#if $isLogin}
            <div
                role="button"
                tabindex="0"
                class="log-out"
                on:click={onLogOut}
                on:keydown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onLogOut();
                    }
                }}
            >
                <span>Cerrar sesión</span>
            </div>
        {/if}
    </div>
    <div class="two-bg-clip" class:two-bg-clip--logged={$isLogin}>
        <div class="two-bg" class:two-bg--logged={$isLogin} use:webp={END_CARD_BG_2}></div>
    </div>
</div>

<style lang="scss">
    .card-end-head {
        position: relative;
        width: 7.5rem;
        margin-top: 0.1rem;
        overflow: visible;
        z-index: 1;
        /* 登录 5.44 + benefit 11.74 + step 6.02 + address 约 2.5 */
        padding-bottom: 25.7rem;
        box-sizing: content-box;
        background: #1c0b00;
    }

    .card-end-head--logged {
        /* 已登录无页内按钮：benefit 10.28 + step 6.02 */
        padding-bottom: 16.3rem;
    }

    .title-section {
        position: relative;
        width: 7.5rem;
        /* title-img bottom (7.66 + 1.2) + 0.14rem gap to login module */
        height: 8.9rem;
        z-index: 2;
        overflow: visible;
    }

    .title-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* 设计稿第一张背景高度 937px */
        height: 9.37rem;
        z-index: 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: top center;
        pointer-events: none;
    }

    .log-out {
        position: absolute;
        top: 0.25rem;
        right: 0.24rem;
        z-index: 3;
        box-sizing: border-box;
        width: 1.79rem;
        height: 0.48rem;
        border-radius: 0.4rem;
        font-size: 0.28rem;
        font-family: DiDiSans-Pro-Regular;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        cursor: pointer;
        border: none;
        outline: none;
        box-shadow: none;
        background: rgba(128, 75, 77, 0.3);
    }

    @supports (color: color(display-p3 1 1 1)) {
        .log-out {
            background: color(display-p3 0.4737 0.3049 0.3049 / 0.3);
        }
    }

    .title-img {
        position: absolute;
        /* 设计稿距第一张背景顶部 766px（不含顶部 download 模块） */
        top: 7.66rem;
        left: 50%;
        width: 4.8rem;
        height: 1.2rem;
        transform: translateX(-50%);
        z-index: 1;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        pointer-events: none;
    }

    .two-bg-clip {
        position: absolute;
        top: 9.37rem;
        left: 0;
        width: 7.5rem;
        /* login 5.44 + benefit 11.74 + step 6.02 - address 间距 0.55 */
        height: 22.65rem;
        overflow: hidden;
        z-index: 0;
        pointer-events: none;
    }

    .two-bg-clip--logged {
        height: 15.75rem;
    }

    .two-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* 设计稿 2321px - address 间距 55px */
        height: 22.66rem;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: top center;
        pointer-events: none;
    }

    .two-bg--logged {
        height: 15.75rem;
    }
</style>
